import { StateCreator } from "zustand";
import { AdminSliceType } from "./admin.type";

const createAdminSlice: StateCreator<AdminSliceType> = (set) => ({
  expanded: true,
  setExpanded: (expanded: boolean) =>
    set(() => {
      return {
        expanded,
      };
    }),
});

export default createAdminSlice;
